






import {
  Component,
  Vue,
} from 'vue-property-decorator'

@Component < NotFoundPage > ({})
export default class NotFoundPage extends Vue {

}
